const timeDetail=[
{
    label:'（UTC+00:00）伦敦',
    codeVal:'Europe/London',
    timeVal:'+8',
    id:0
},
{
    label:'（UTC+01:00）罗马、巴黎',
    codeVal:'Europe/Paris',
    timeVal:'+7',
    id:1
},
{
    label:'（UTC+02:00）雅典、以色列',
    codeVal:'Europe/Athens',
    timeVal:'+6',
    id:2
},
{
    label:'（UTC+03:00）莫斯科、科威特',
    codeVal:'Europe/Moscow',
    timeVal:'+5',
    id:3
},
{
    label:'（UTC+04:00）喀布尔',
    codeVal:'Asia/Kabul',
    timeVal:'+4',
    id:4
},
{
    label:'（UTC+05:00）伊斯兰堡、卡拉奇',
    codeVal:'Asia/Karachi',
    timeVal:'+3',
    id:5
},
{
    label:'（UTC+06:00）阿拉木图、科伦坡',
    codeVal:'Asia/Colombo',
    timeVal:'+2',
    id:6
},
{
    label:'（UTC+07:00）曼谷、雅加达',
    codeVal:'Asia/Bangkok',
    timeVal:'+1',
    id:7
},
{
    label:'（UTC+08:00）北京、香港、台湾',
    codeVal:'Asia/Shanghai',
    timeVal:'+0',
    id:8
},
{
    label:'（UTC+09:00）东京',
    codeVal:'Asia/Tokyo',
    timeVal:'-1',
    id:9
},
{
    label:'（UTC+10:00）悉尼',
    codeVal:'Australia/Sydney',
    timeVal:'-2',
    id:10
},
{
    label:'（UTC+11:00）霍尼亚拉、马加丹',
    codeVal:'Asia/Magadan',
    timeVal:'-3',
    id:11
},
{
    label:'（UTC+12:00）奥克兰',
    codeVal:'Pacific/Auckland',
    timeVal:'-4',
    id:12
},
{
    label:'（UTC-11:00）帕果帕果、阿洛菲',
    codeVal:'Pacific/Pago_Pago',
    timeVal:'-5',
    id:13
},
{
    label:'（UTC-10:00）夏威夷',
    codeVal:'US/Hawaii',
    timeVal:'-6',
    id:14
},
{
    label:'（UTC-09:00）阿拉斯加',
    codeVal:'US/Alaska',
    timeVal:'-7',
    id:15
},
{
    label:'（UTC-08:00）洛杉矶、旧金山',
    codeVal:'America/Los_Angeles',
    timeVal:'-8',
    id:16
},
{
    label:'（UTC-07:00）盐湖城、丹佛、凤凰城',
    codeVal:'America/Phoenix',
    timeVal:'-9',
    id:17
},
{
    label:'（UTC-06:00）芝加哥、休斯顿、亚特兰大',
    codeVal:'America/Chicago',
    timeVal:'+14',
    id:18
},
{
    label:'（UTC-05:00）纽约、华盛顿、波士顿',
    codeVal:'America/New_York',
    timeVal:'+13',
    id:19
},
{
    label:'（UTC-04:00）加拿大、加拉加斯',
    codeVal:'America/Caracas',
    timeVal:'+12',
    id:20
},
{
    label:'（UTC-03:00）巴西利亚',
    codeVal:'America/Buenos_Aires',
    timeVal:'+11',
    id:21
},
{
    label:'（UTC-02:00）协调世界时',
    codeVal:'Brazil/DeNoronha',
    timeVal:'+10',
    id:22
},
{
    label:'（UTC-01:00）佛得角群岛',
    codeVal:'Atlantic/Cape_Verde',
    timeVal:'+9',
    id:23
},
]
export default timeDetail;


